// extracted by mini-css-extract-plugin
module.exports = {"image":"GC-z","loaded":"HC-z","placeholder":"IC-z"};